// src/components/SalaScreen.jsx
import React, { useState } from "react";
import { ref, set, get, update } from "firebase/database";
import { db } from "../firebase";
import "./SalaScreen.css";

function generarCodigoSala() {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  let code = "";
  for (let i = 0; i < 5; i++) code += chars[Math.floor(Math.random() * chars.length)];
  return code;
}

function SalaScreen({ onEntrarSala }) {
  const [codigo, setCodigo] = useState("");
  const [nombre, setNombre] = useState("");
  const [error, setError] = useState("");

  // Crear nueva sala
  const crearSala = async () => {
    if (!nombre.trim()) {
      setError("Introduce tu nombre");
      return;
    }
    const codigoSala = generarCodigoSala();
    const salaRef = ref(db, `salas/${codigoSala}`);
    await set(salaRef, {
      jugadores: {
        [nombre]: { nombre }
      },
      estado: "esperando",
      creador: nombre,
      turno: 0
    });
    onEntrarSala(codigoSala, nombre);
  };

  // Unirse a sala existente
  const unirseSala = async () => {
    if (!nombre.trim() || !codigo.trim()) {
      setError("Rellena tu nombre y el código");
      return;
    }
    const salaRef = ref(db, `salas/${codigo.toUpperCase()}`);
    const snapshot = await get(salaRef);
    if (!snapshot.exists()) {
      setError("No existe esa sala");
      return;
    }
    // Añade el jugador a la sala
    await update(salaRef, {
      [`jugadores/${nombre}`]: { nombre }
    });
    onEntrarSala(codigo.toUpperCase(), nombre);
  };

  return (
    <div className="sala-panel">
      <h2>
        <span role="img" aria-label="gamepad">🎮</span> Partida Online
      </h2>
      <input
        type="text"
        value={nombre}
        onChange={e => setNombre(e.target.value)}
        placeholder="Tu nombre"
        maxLength={16}
        autoFocus
      />
      <button className="btn-crearsala" onClick={crearSala}>
        + Crear nueva sala
      </button>
      <div style={{ marginTop: "1.3rem", width: "100%", textAlign: "center" }}>
        <input
          type="text"
          value={codigo}
          onChange={e => setCodigo(e.target.value)}
          placeholder="CÓDIGO DE SALA"
          maxLength={5}
          style={{ textTransform: "uppercase", width: 140, marginRight: 8 }}
        />
        <button className="btn-unirsesala" onClick={unirseSala}>
          Unirse
        </button>
      </div>
      {error && <div className="error-msg">{error}</div>}
    </div>
  );
}

export default SalaScreen;
